import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {map} from 'rxjs/operators';
import {UserListResponse} from './user-list-response';
import {UpdateUserRequestModel} from './update-user-request-model';
import {UserModel} from './user-model';
import {AddUserRequestModel} from './add-user-request-model';
import {ChangePasswordRequestModel} from './change-password-request-model';

@Injectable({
  providedIn: 'root'
})
export class UsersService {

  constructor(private httpClient: HttpClient) { }

  public getList(organizationId: string): Observable<UserListResponse> {
    return this.httpClient.get<UserListResponse>(`/api/organizations/${organizationId}/users`);
  }

  public getOne(organizationId: string, userId: string): Observable<UserModel> {
    return this.httpClient.get<UserModel>(`/api/organizations/${organizationId}/users/${userId}`);
  }

  public update(organizationId: string, userId: string, request: UpdateUserRequestModel): Observable<UserModel> {
    return this.httpClient.put<UserModel>(`/api/organizations/${organizationId}/users/${userId}`, request);
  }

  public add(organizationId: string, request: AddUserRequestModel): Observable<UserModel> {
    return this.httpClient.post<UserModel>(`/api/organizations/${organizationId}/users`, request);
  }

  public deactivate(organizationId: string, userId: string): Observable<object> {
    return this.httpClient.post(`/api/organizations/${organizationId}/users/${userId}/deactivate`, null);
  }

  public activate(organizationId: string, userId: string): Observable<object> {
    return this.httpClient.post(`/api/organizations/${organizationId}/users/${userId}/activate`, null);
  }

  public changePassword(organizationId: string, userId: string, request: ChangePasswordRequestModel): Observable<object> {
    request.executorId = 'XXX';
    return this.httpClient.post(`/api/organizations/${organizationId}/users/${userId}/changePassword`, request);
  }
}
